import { GameState } from "../../../../games/state/types"

export const isGameInProgress = (state: GameState) => {
  return state.gameRound?.inmProgress ?? false
}
